<template>
  <div class="error">
    <img src="../../assets/eeor.png" alt="" />
    <div class="bottou">
      <el-button @click="poat()" type="primary">返回首页</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    poat() {
      this.$router.push("/Home");
    },
  },
};
</script>
<style lang="scss" scoped>
.error {
  width: 100%;
  height: 100%;
  img {
    // width: 50%;
    // height: 90%;
  }
}
.bottou {
  text-align: center;
}

@media (max-width: 768px) {
  .error {
    width: 100vw;
    img {
      width: 100vw;
    }
  }
  .bottou {
    text-align: center;
  }
}
</style>
